import * as React from 'react';
import {useDebounce} from 'src/hooks/useDebounce';

import {SearchInput} from '@spaced-out/ui-design-system/lib/components/SearchInput';
import type {SearchInputProps} from '@spaced-out/ui-design-system/lib/components/SearchInput';


export type DebouncedSearchInputProps = Omit<
  SearchInputProps,
  'onChange' | 'value'
> & {
  classNames?: Partial<{
    container: string;
    input: string;
  }>;
  value: string;
  onChange: (value: string) => unknown;
  placeholder?: string;
  debounceTime?: number;
  size?: 'medium' | 'small';
};

export const DebouncedSearchInput = ({
  classNames,
  value,
  onChange,
  placeholder = 'Search',
  debounceTime = 300,
  size = 'medium',
  ...searchInputProps
}: DebouncedSearchInputProps) => {
  const [query, setQuery] = React.useState(value);
  const debouncedQueryValue = useDebounce(query, debounceTime);
  React.useEffect(() => {
    onChange(debouncedQueryValue);
  }, [debouncedQueryValue]);

  React.useEffect(() => {
    if (value !== query) {
      setQuery(value);
    }
  }, [value]);
  return (
    <SearchInput
      {...searchInputProps}
      classNames={{wrapper: classNames?.container}}
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      placeholder={placeholder}
      onClear={() => setQuery('')}
      size={size}
    />
  );
};
